import { BLACK, LILAC_300, LILAC_400, LILAC_700, fitContentWidth, tokens } from '@airtel/air-design-system';
import { StyleSheet } from 'react-native';
export var getCounterVariantColor = () => {
  return {
    backgroundColor: LILAC_400,
    color: BLACK,
    text: BLACK,
    disabledBackgroundColor: LILAC_300,
    disabledIconColor: LILAC_700
  };
};
export var getCounterWidgetStyles = props => {
  var _props$size = props.size,
    size = _props$size === void 0 ? 'sm' : _props$size;
  var spacingToken = tokens.spacing;
  var avatarSizes = {
    sm: 28,
    md: 36
  };
  var colorTypes = getCounterVariantColor();
  return StyleSheet.create({
    counterContainer: Object.assign({
      flexDirection: 'row',
      alignItems: 'center',
      borderRadius: tokens.borderRadius.BORDER_RADIUS_24,
      borderWidth: spacingToken.SPACING_1,
      borderColor: colorTypes.backgroundColor,
      padding: spacingToken.SPACING_4
    }, fitContentWidth()),
    iconsContainer: {
      alignItems: 'center',
      justifyContent: 'center',
      width: avatarSizes[size],
      height: avatarSizes[size],
      borderRadius: 100,
      backgroundColor: colorTypes.backgroundColor
    },
    countText: {
      marginHorizontal: spacingToken.SPACING_4
    },
    disabledStyles: {
      backgroundColor: colorTypes.disabledBackgroundColor
    }
  });
};